import { statusColorObj } from '../../../../../../themes';

export const COLORS = {
  OFF: statusColorObj.off,
  ON: statusColorObj.on,
  DANGER: statusColorObj.danger,
  WARNING: statusColorObj.warning,
  HIGH: statusColorObj.warning,
  LOW: statusColorObj.warning,
  HIGHEST: statusColorObj.danger,
  LOWEST: statusColorObj.danger,
  NORMAL: statusColorObj.normal,
};

export const getEnumReadingSize = reading => {
  if (reading.length > 70) {
    return 'h5';
  }
  if (reading.length > 20) {
    return 'h4';
  }
  return 'h3';
};

export const getEnumReadingString = (reading, isAssetDetails) => {
  if (isAssetDetails && reading.length > 70) {
    return `${reading.slice(0, 70)}...`;
  }
  if (reading.length > 100) {
    return `${reading.slice(0, 100)}...`;
  }
  return reading;
};
